<template>
  <ion-card class="promotion">
    <ion-item class="promotion-header" lines="none">
      <ion-avatar class="avatar link" slot="start">
        <ion-img :src="poi.logo" :alt="poi.name" @click.prevent="goToRoute" />
      </ion-avatar>
      <div class="header-name">
        <ion-label @click.prevent="goToRoute" class="promotion-header__pet-name link">
          {{ poi.name }}
        </ion-label>
      </div>
    </ion-item>
    <div class="promotion-thumbnail-container" lines="none">
      <ion-item v-double-click="likeAdvert" style="position: relative; --padding-start: 0; --inner-padding-end: 0">
        <ion-img :src="promotionImage" :alt="`${poi.name} promóciós kép`" class="promotion-thumbnail" />

        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="23"
          height="22"
          fill="none"
          viewBox="0 0 23 22"
          class="advert-paw"
        >
          <path
            fill="#fff"
            d="M11.766 7.85c.09 1.432.874 2.511 1.75 2.41.877-.1 1.514-1.344 1.424-2.776-.09-1.432-.874-2.511-1.75-2.41-.877.101-1.515 1.344-1.424 2.776zM14.777 10.265c-.393 1.098-.177 2.166.481 2.384.658.218 1.51-.496 1.903-1.595.392-1.099.177-2.166-.482-2.384-.658-.218-1.51.496-1.902 1.595zM11.505 10.283l2.636 2.64c.131.185.279.509.3.882.02.373-.087.796-.467 1.177-.38.38-.781.537-1.182.517-.4-.02-.802-.22-1.17-.54-.346.368-.724.615-1.117.694-.398.08-.806-.015-1.203-.335-.398-.322-.527-.727-.525-1.102.002-.375.133-.72.253-.923v-.002l2.475-3.008zM8.422 12.822c-.614.379-1.554-.11-2.099-1.09-.544-.981-.487-2.083.128-2.461.615-.378 1.554.11 2.099 1.09.544.982.487 2.083-.128 2.461zM9.86 10.437c-.876.102-1.66-.977-1.75-2.41-.09-1.432.547-2.675 1.423-2.776.877-.1 1.66.978 1.75 2.41.091 1.432-.546 2.675-1.423 2.776z"
          />
        </svg>

        <ion-item
          button
          fill="clear"
          shape="round"
          size="small"
          strong
          class="promotion-like"
          lines="none"
          @click.prevent="toggleLikeAdvert"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="33"
            height="28"
            viewBox="0 0 33 28"
            fill="none"
            class="paw-icon"
          >
            <circle
              cx="16"
              cy="13"
              r="9"
              :fill="promotion.liked ? '#E6224A' : '#000'"
              :opacity="promotion.liked ? 1 : 0.5"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M23.9481 0.0502126C21.4032 0.00470754 19.5688 0.444516 18.0529 1.37836C17.6067 1.65326 17.2096 2.01743 16.7897 2.32704C16.6473 2.43203 16.5883 2.60823 16.401 2.67489C16.0907 2.2292 15.5274 1.90963 15.0729 1.59972C14.1984 1.00338 13.2447 0.597032 12.0606 0.271571C11.6438 0.157034 11.2525 0.210192 10.7973 0.113458C10.3316 0.0144789 9.4818 -0.0270732 8.98343 0.0818352H8.46518L7.2991 0.239949C3.9524 1.12358 1.99459 3.10708 0.950472 6.24826C0.690016 7.03183 0.562072 7.87439 0.56178 8.93618V9.94811C0.782978 10.8968 0.836132 11.7942 1.17721 12.6044C1.8579 14.2213 2.68825 15.5978 3.67131 16.9051C4.00886 17.3539 4.4258 17.7535 4.77261 18.2016L5.06413 18.4546C5.59375 19.138 6.3722 19.8987 7.07237 20.4152C7.38656 20.647 7.63108 21.0044 7.94692 21.2374C8.69807 21.7914 9.37935 22.4038 10.1495 22.945C10.6529 23.2988 11.1306 23.7327 11.6395 24.0834C12.7228 24.83 13.8103 25.5359 14.9434 26.2338C15.3262 26.4696 15.712 26.717 16.1094 26.9611C16.2191 27.0284 16.3465 27.1858 16.4657 27.1508C16.8693 27.0317 17.4647 26.5209 17.8262 26.297C19.0707 25.5263 20.2423 24.7067 21.4216 23.8937C22.5501 23.1158 23.5696 22.2599 24.6607 21.4588C25.0569 21.1678 25.3691 20.737 25.762 20.4468C26.4853 19.9126 27.2882 19.1295 27.835 18.423C28.2047 17.9453 28.7277 17.5234 29.0982 17.0316C30.0352 15.7881 30.913 14.4779 31.5599 12.9523C31.9435 12.0479 32.0558 11.0847 32.3049 10.0114V8.46184C32.3049 6.99072 31.7222 5.25613 31.1389 4.31927C30.0476 2.56659 28.6235 1.34535 26.5717 0.524553C26.029 0.307431 25.4078 0.251775 24.7902 0.113458C24.5358 0.0565371 24.1479 0.172118 23.9481 0.0502126ZM19.1866 6.91233C19.3672 7.02187 19.6324 6.99386 19.802 7.10207C20.1333 7.3134 20.4223 7.73882 20.547 8.14562C20.9666 9.51421 20.2062 10.8455 19.4133 11.3711C19.17 11.5324 18.7333 11.8257 18.2149 11.6874C17.3739 11.4628 16.6582 10.3184 16.984 9.0943C17.2638 8.04325 17.8609 6.92833 19.1866 6.91233ZM13.4534 6.91233C13.5965 6.99831 13.8157 6.97422 13.9716 7.03882C14.228 7.14498 14.5885 7.39869 14.749 7.60803C15.0318 7.97072 15.2507 8.37682 15.3968 8.80969C15.8155 10.0932 15.2277 11.4461 14.2308 11.6874C13.5956 11.8411 13.1609 11.4561 12.8703 11.2446C11.6279 10.3402 11.1499 6.94323 13.4534 6.91233ZM9.8256 10.8335C9.94953 10.9089 10.1297 10.8732 10.2791 10.9284C10.4851 11.0118 10.6807 11.1179 10.8621 11.2446C11.7545 11.8743 12.7454 14.3509 11.0241 14.8496C10.6018 14.972 10.1836 14.7927 9.92277 14.6599C9.19951 14.2912 8.74474 13.6859 8.49757 12.8574C8.16601 11.7462 8.85523 10.8454 9.8256 10.8335ZM23.0087 10.8652C23.1235 10.9429 23.2773 10.9499 23.3974 11.0233C23.6792 11.1953 23.8902 11.553 23.9805 11.9087C24.2861 13.1138 23.2382 14.2973 22.5229 14.6599C22.1905 14.8284 21.6733 14.9739 21.2272 14.7864C20.6029 14.5239 20.2944 13.5484 20.5794 12.6993C20.914 11.7021 21.6159 10.8445 23.0087 10.8652ZM16.5953 12.6677C16.6994 12.733 16.8563 12.7171 16.984 12.7625C17.3086 12.8779 17.6675 13.0018 17.9557 13.1736C19.436 14.0559 20.5724 15.3069 21.13 17.0948C21.3689 17.8605 21.5297 19.309 21.0329 19.9409C20.8256 20.2045 20.221 20.246 19.802 20.1306C19.2179 19.9697 18.619 19.773 18.0529 19.593C17.6217 19.4559 17.1516 19.442 16.6925 19.34C16.3243 19.2583 15.7439 19.3356 15.4616 19.4033C14.6015 19.6095 13.8964 19.7053 13.1295 19.9725C12.7383 20.1088 11.989 20.3389 11.5747 20.0674C10.8535 19.5947 11.0791 17.5913 11.3804 16.8102C12.0761 15.006 13.6193 13.3075 15.5588 12.7309C15.8546 12.643 16.2239 12.6671 16.5953 12.6677Z"
              fill="white"
            />
          </svg>
          <ion-text v-if="promotion.likes > 0">
            {{ promotion.likes }}
          </ion-text>
        </ion-item>
      </ion-item>
      <div class="cta-box" @click="goToRoute">
        {{ promotion.cta_title }}

        <lottie-animation
          ref="anim"
          :autoPlay="true"
          :playInterval="2100"
          :animationData="require('@/assets/images/lottie/promotion.json')"
        />
      </div>
    </div>
    <ion-card-content class="promotion-content">
      <b>{{ poi.name }}</b> {{ promotion.text }}
    </ion-card-content>
  </ion-card>
</template>

<script>
import { computed, defineComponent, onMounted, ref } from 'vue'
import { IonCard, IonItem, IonCardContent, IonAvatar, IonImg, IonLabel, IonText, createAnimation } from '@ionic/vue'

import useAuth from '@/composables/auth'
import useNavigation from '@/composables/navigation'

import httpClient from '@/core/api/api.service'

export default defineComponent({
  name: 'Promotion',
  components: {
    IonCard,
    IonItem,
    IonCardContent,
    IonAvatar,
    IonImg,
    IonLabel,
    IonText,
  },
  props: {
    promotion: {
      type: Object,
      required: true,
    },
  },
  emits: ['scroll-to-hash'],
  setup(props, { emit }) {
    const { isAuthenticated } = useAuth()
    const { openBrowserLink } = useNavigation()

    const promotion = ref({ ...props.promotion })
    const poi = ref(props.promotion.poi)
    const images = ref(props.promotion.images)

    const promotionImage = computed(() => images.value[Math.floor(Math.random() * images.value.length)])

    const goToRoute = async () => {
      try {
        await httpClient.save(`adverts/${promotion.value.id}/click`)
      } catch {
        console.warn('Could not save click statistics..')
      } finally {
        openBrowserLink(promotion.value.target_url)
      }
    }

    onMounted(() => emit('scroll-to-hash'))

    const likeAnimation = createAnimation().duration(1200).easing('cubic-bezier(0.230, 1.000, 0.320, 1.000)')

    const likeAnimationScale = createAnimation()
      .afterClearStyles(['opacity', 'transform'])
      .keyframes([
        {
          offset: 0,
          transform: 'scale(1)',
        },
        {
          offset: 0.3,
          transform: 'scale(1.3)',
        },
        {
          offset: 0.7,
          transform: 'scale(1.2)',
        },
        {
          offset: 0.8,
          transform: 'scale(1.3)',
        },
        {
          offset: 1,
          transform: 'scale(1)',
        },
      ])

    const likeAnimationPaw = createAnimation()
      .afterClearStyles(['opacity', 'transform'])
      .keyframes([
        {
          offset: 0,
          transform: 'scale(.9)',
          opacity: 0,
        },
        {
          offset: 0.1,
          opacity: 0.95,
        },
        {
          offset: 0.3,
          transform: 'scale(1)',
        },
        {
          offset: 0.8,
          transform: 'scale(1)',
        },
        {
          offset: 0.9,
          opacity: 0.95,
        },
        {
          offset: 1,
          transform: 'scale(0)',
          opacity: 0,
        },
      ])

    const playAnimation = async target => {
      await likeAnimation
        .addAnimation([
          likeAnimationScale.addElement(target.closest('.promotion').querySelector('.paw-icon')),
          likeAnimationPaw.addElement(target.closest('.promotion').querySelector('.advert-paw')),
        ])
        .play()
    }

    const likeAdvert = async event => {
      if (!isAuthenticated.value) {
        return
      }

      const target = event.currentTarget
      playAnimation(target)

      if (!promotion.value.liked) {
        try {
          promotion.value.likes++
          promotion.value.liked = true

          await httpClient.save(`adverts/${promotion.value.id}/like`)

          Promise.resolve()
        } catch (error) {
          Promise.reject(error)
        }
      }
    }

    const toggleLikeAdvert = async event => {
      if (!isAuthenticated.value) {
        return
      }

      try {
        if (promotion.value.liked) {
          promotion.value.likes--
          promotion.value.liked = false
        } else {
          const target = event.currentTarget
          playAnimation(target)

          promotion.value.likes++
          promotion.value.liked = true
        }

        await httpClient.save(`adverts/${promotion.value.id}/like`)

        Promise.resolve()
      } catch (error) {
        Promise.reject(error)
      }
    }

    return {
      promotion,
      poi,
      promotionImage,
      goToRoute,
      likeAdvert,
      toggleLikeAdvert,
    }
  },
})
</script>

<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Lobster&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@800&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@900&display=swap');

.promotion {
  margin: 0;
  box-shadow: none;
  width: 100%;
  position: relative;

  &:not(.review):after {
    content: '';
    display: block;
    margin-top: 15px;
    height: 1px;
    width: 100%;

    opacity: 0.6;
    background: linear-gradient(90deg, rgba(196, 196, 196, 0) 0.07%, #c4c4c4 51.56%, rgba(196, 196, 196, 0) 100%);
  }
}

.promotion-header {
  --inner-padding-end: 20px;
  --padding-start: 10px;
  --background: transparent;
  --border-color: transparent;
  margin-bottom: -18px;
  overflow: visible;

  .header-name {
    margin-bottom: 18px;
    display: flex;
    flex-direction: column;

    p {
      margin: 0;
      font-family: 'Open Sans', sans-serif;
      font-size: 11px;
      font-weight: 600;
      margin-top: -8px;
      width: 50%;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  &__pet-name {
    font-family: Lobster, sans-serif;
    font-size: 20px;
    pointer-events: all;
  }
}

.avatar {
  position: relative;
  white-space: nowrap;
  border: 6px solid #fff;
  background: #fff;
  width: 62px;
  height: 62px;
  min-width: 62px;

  margin: 0 12px;

  box-shadow: 0px 6px 7px rgba(0, 0, 0, 0.2);
}

.promotion-content {
  text-align: left;
  color: var(--ion-text-color);
  padding: 10px 20px;
  font-size: 14px;

  b {
    font-family: 'Poppins', sans-serif;
  }
}

.promotion-paw {
  position: absolute;
  top: calc(50% - 110px);
  left: calc(50% - 115px);
  width: 230px;
  height: 220px;
  pointer-events: none;
  touch-action: none;
  opacity: 0;
  transform: scale(0.9);
}

.promotion-like {
  --background: rgba(0, 0, 0, 0);
  --ripple-color: rgba(0, 0, 0, 0);
  --padding-start: 13px;
  --padding-end: 0;
  position: absolute;
  bottom: 10px;
  left: 0;
  margin: 0;
  height: 40px;
  margin-left: -3px;

  &:hover {
    --background-hover: rgba(0, 0, 0, 0);
  }

  @media (min-width: 768px) {
    height: 45px;
  }

  svg {
    margin-left: 5px;
    margin-right: 5px;

    @media (min-width: 768px) {
      height: 30px;
      width: 32px;
    }
  }

  ion-text {
    background: rgba(0, 0, 0, 0.5);
    border-radius: 30px;
    display: inline-block;
    color: #fff;
    font-weight: bold;
    font-size: 12px;
    font-family: 'Poppins', sans-serif;

    @media (max-width: 768px) {
      padding: 3px 10px;
    }

    @media (min-width: 768px) {
      padding: 3px 10px;
    }
  }
}

.promotion-thumbnail-container {
  position: relative;
  padding: 0 12px;
  z-index: 0;

  .promotion-thumbnail {
    width: 100%;

    &::part(image) {
      border-radius: 15px 15px 0 0;
    }
  }

  .cta-box {
    background-color: #ff2871;
    border-radius: 0 0 15px 15px;
    padding: 16px 24px;
    color: #fff;
    font-size: 15px;
    font-weight: 900;
    letter-spacing: -0.5px;
    line-height: 16px;
    font-family: 'Montserrat', sans-serif;
    position: relative;
    cursor: pointer;

    .lottie-animation {
      height: 16px;
      position: absolute;
      right: 12px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}

.advert-paw {
  position: absolute;
  top: calc(50% - 110px);
  left: calc(50% - 115px);
  width: 230px;
  height: 220px;
  pointer-events: none;
  touch-action: none;
  opacity: 0;
  transform: scale(0.9);
}
</style>
